import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const updateVendorMasterQuery = (data) => axios.put(apiurl?.updateVendorMaster, data);

const updateVendorMaster = () => {
  const queryClient = useQueryClient();
  return useMutation(updateVendorMasterQuery, {
    onSuccess: () => {
      queryClient.invalidateQueries('getvendorlist');
    }
  });
};

export default updateVendorMaster;
